export const TAX_META_IMG = 'https://images.ctfassets.net/heg7gyzix6dq/6DlgY1i9XO2kUWSE8AUW2e/5b5b57c8f06613e99ab6137b5a4f11a1/StrideTax_Logo_stacked_black.png';
